import {
    CreditCardPaymentScheme,
    CreditCardStatus,
    CreditCardToken,
    CreditCardTokenStatus,
    CreditCardWalletType,
    CustomerRole,
    KredittbankenCardProduct,
    WalletCreditCard,
    WalletCreditCardStatus,
} from '@generated-types';

export const pendingCardTokenMock1: CreditCardToken = {
    cardId: '4563711',
    created: new Date('2025-04-16'),
    device: {
        id: '044D1DB3F44E80018330014051948844E7D10F64289D799C',
        type: 'MOBILE_PHONE',
    },
    eikaCardId: 'MDEzNTM2NDI0NzFfNDTEgcSDKsSQxJHEjTA2X8SKMzAwMzc5MzE3xJxfQ1JFRElU',
    expiryDate: new Date('2031-03-31'),
    id: '14203173',
    number: '440379******0036',
    panReferenceId: 'V-card-1',
    paymentScheme: CreditCardPaymentScheme.VISA,
    requestor: {
        id: '40010030273',
        name: 'ApplePay',
    },
    status: CreditCardTokenStatus.INACTIVE,
    uniqueReferenceId: 'DNITHE-phone-1',
    walletType: CreditCardWalletType.APPLE_PAY,
};

export const eligibleCreditCardsMock1: WalletCreditCard[] = [
    {
        id: '4563711',
        eikaCardId: 'MDEyMzQ1Njc4OTBfNDQxMzUzKsSSxJM1MjAzXzHEmTnEiTc2xJwzMjZfQ1JFRElU',
        accountId: '2509617',
        number: '441353******5203',
        accountNumber: '01234567890',
        cardHolder: {
            firstName: 'Possessiv',
            lastName: 'Forelder',
            role: CustomerRole.ACCOUNT_OWNER,
            customerNumber: {
                value: '19907699326',
            },
            name: 'Possessiv Forelder',
        },
        product: KredittbankenCardProduct.KREDITTBANKEN_VISA,
        status: WalletCreditCardStatus.ELIGIBLE,
        cardStatus: CreditCardStatus.NORMAL,
        walletType: CreditCardWalletType.APPLE_PAY,
        tokens: [],
    },
    {
        id: '4563711',
        eikaCardId: 'MDEyMzQ1Njc4OTBfNDQxMzUzKsSSxJM1MjAzXzHEmTnEiTc2xJwzMjZfQ1JFRElU',
        accountId: '2509617',
        number: '441353******5203',
        accountNumber: '01234567890',
        cardHolder: {
            firstName: 'Possessiv',
            lastName: 'Forelder',
            role: CustomerRole.ACCOUNT_OWNER,
            customerNumber: {
                value: '19907699326',
            },
            name: 'Possessiv Forelder',
        },
        product: KredittbankenCardProduct.KREDITTBANKEN_VISA,
        status: WalletCreditCardStatus.ELIGIBLE,
        cardStatus: CreditCardStatus.NORMAL,
        walletType: CreditCardWalletType.GOOGLE_PAY,
        tokens: [],
    },
];
